import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import A from "../../../common/A";
import { MESSAGE, URL } from '../../../../constant';
import { useAlert, useUserInfo } from '../../../../hooks';
import XbtnTitleHeader from '../../../common/header/XbtnTitleHeader';
import { membersInfo } from '../../../../api/accountAPI';
import { wpinDeAPI } from '../../../../api/commonAPI';

function AppIdSignSuccess() {
  const [Alert] = useAlert();
  const { info } = useUserInfo();
  const history = useHistory();
  const location = useLocation();

  const [email, setEmail] = useState('');

  useEffect(() => {
    const { state } = location;

    if (info?.emailCertYn === 'Y') {
      appAuthCheck();
    } else if (state?.email) {
      setEmail(state.email);
    } else {
      Alert(
        MESSAGE.INVALID_ACCESS,
        () => { history.push(URL.ACCOUNT.APP_ID_SIGN)},
        "msg005"
      )
    }
  }, []);

  const appAuthCheck = useCallback(async () => {
    const { userId } = info;
    const data = await membersInfo(userId);

    if (data?.code === 'S000000') {
      const email = await wpinDeAPI({ type: 'E', str: data.resp.emailAdrsEn });
      setEmail(email ? email : data.resp?.emailAdrs);
    }
  }, [])


  return (
    <div className="layout-def layout-lc bg_gray2 with_bottom_area">
      <XbtnTitleHeader
        title="APP 계정 신청"
        onClose={() => history.push(URL.SELECT_LEARNING)}
      />
      <div className="container">
        <div className="inner">
          <div className="app_acc_done">
            <div className="mail">{email}</div>
            <div className="txt">APP 계정 신청이 완료되었습니다.</div>
            <div className="link_wrap">
              <A
                onClick={() => {
                  history.push({
                    pathname: URL.ACCOUNT.APP_ID_SIGN,
                    state: {
                      type: 'change'
                    }
                  })
                }}
              >
                APP 계정 변경하기
              </A>
            </div>
          </div>
          <div className="bottom_wrap">
            <div className="google_bnr">
              <div className="txt1">
                구글 플레이에서
                <br />
                AI 바로셈을 검색해 주세요.
              </div>
              <div className="txt2">
                원하시는 기기에서 AI바로셈 앱을 다운로드 받아
                <br />
                신청하신 계정으로 로그인 후 이용하세요.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppIdSignSuccess;